<template>
  <div>
    <view-options elementId="GoogleMaxPerformance" />
    <div class="product-view" id="GoogleMaxPerformance">
      <div>
        <div class="lds-ellipsis" v-if="Product.length === 0">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <ad-goals
          v-bind:totalImpressions="productData.totalImpressions"
          v-bind:totalClicks="productData.totalClicks"
          :wording="wordings"
        ></ad-goals>
        <section class="widget brand-impact">
          <h3 class="widget-title">Impacto de su marca en el tiempo</h3>
          <card type="line-chart">
            <div class="card-top">
              <div class="card-header">
                <h4 class="card-title">Impresiones y clicks</h4>
              </div>
            </div>
            <div class="card-content">
              <impressions
                :totalImpressions="Product.totalImpressions || 0"
                :impressions="Product.impressions || []"
                :clicks="Product.clicks || []"
                :imp="impressionsChartOptions"
                :labelType="'Clicks'"
              ></impressions>
            </div>
          </card>
        </section>
      </div>
      <mq-layout mq="laptop+">
        <section class="mobile-canvas">
          <img src="@/assets/images/max-performance-phone.png" alt />
        </section>
      </mq-layout>
      <section class="widget campaign-widget" v-if="campaignData.length !== 0">
        <h3 class="widget-title">Campañas</h3>
        <card>
          <table class="table">
            <thead>
              <th>Campaña</th>
              <th>Impresiones</th>
              <th>Clicks</th>
              <th>CTR</th>
              <th>CPC medio</th>
              <th v-if="!isAxesa">Conversions</th>
              <th v-if="isAxesa">Phone Calls</th>
              <th v-if="!isAxesa">Tasa de Conversión</th>
            </thead>
            <tbody>
              <tr v-for="(campaignData, index) in campaignData" :key="index">
                <td>{{ campaignData.name }}</td>
                <td>{{ Number(campaignData.impressions).toLocaleString() }}</td>
                <td>{{ Number(campaignData.clicks).toLocaleString() }}</td>
                <td>{{ campaignData.ctr.toFixed(2) }}%</td>
                <td>${{ campaignData.cpc.toFixed(2) }}</td>
                <td v-if="!isAxesa">{{ Number(campaignData.conversion).toLocaleString() }}</td>
                <td v-if="isAxesa">
                  {{ Number(campaignData.phoneCalls).toLocaleString() }}
                </td>
                <td v-if="!isAxesa">{{ Number(campaignData.conversionRate).toFixed(2) }}%</td>
              </tr>
            </tbody>

            <thead>
              <tr>
                <th>Total</th>
                <th>{{ TotalCampains.Impresiones.toLocaleString() }}</th>
                <th>{{ TotalCampains.Clicks.toLocaleString() }}</th>
                <th>{{ TotalCampains.CTR.toFixed(2).toLocaleString() }}%</th>
                <th>${{ TotalCampains.CPC.toFixed(2).toLocaleString() }}</th>
                <th v-if="!isAxesa">{{ totalConversions.toLocaleString() }}</th>
                <th v-if="isAxesa">{{ TotalPhoneCalls.toLocaleString() }}</th>
                <th v-if="!isAxesa">{{ TotalCampains.ConversionRate.toFixed(2) }}%</th>
              </tr>
            </thead>
          </table>
        </card>
      </section>
      <section
        class="widget campaign-widget"
        v-if="campaignLocationData.length !== 0"
      >
        <h3 class="widget-title">Ubicaciones de la campaña</h3>
        <card class="responsive-table">
          <table class="table">
            <thead>
              <th>Campaña</th>
              <th>Ubicación de la segmentación</th>
              <th>Impresiones</th>
              <th>Clicks</th>
              <th>CTR</th>
              <th>CPC medio</th>
              <th>Conversions</th>
              <th>Tasa de Conversión</th>
            </thead>
            <tbody>
              <tr
                v-for="(campaignLocationData, index) in campaignLocationData"
                :key="index"
              >
                <td>{{ campaignLocationData.name }}</td>
                <td>{{ campaignLocationData.location }}</td>
                <td>
                  {{
                    Number(campaignLocationData.impressions).toLocaleString()
                  }}
                </td>
                <td>
                  {{ Number(campaignLocationData.clicks).toLocaleString() }}
                </td>
                <td>{{ campaignLocationData.ctr.toFixed(2) }}%</td>
                <td>${{ campaignLocationData.cpc.toFixed(2) }}</td>
                <td>{{ Number(campaignLocationData.conversion).toLocaleString() /* Conversions */ }}</td> 
                <td>{{ campaignLocationData.conversionRate.toFixed(2) /* Conversions */ }}%</td> 
              </tr>
            </tbody>

            <thead>
              <tr>
                <th colspan="2">Total</th>
                <th>{{ TotalLocationCampains.Impresiones.toLocaleString() }}</th>
                <th>{{ TotalLocationCampains.Clicks.toLocaleString() }}</th>
                <th>{{ TotalCampains.CTR.toFixed(2).toLocaleString() }}%</th>
                <th>${{ TotalCampains.CPC.toFixed(2).toLocaleString() }}</th>
                <th>{{ TotalLocationCampains.Conversions.toLocaleString() /* Conversions */ }}</th>
                <th>{{ TotalLocationCampains.ConversionRate.toFixed(2).toLocaleString() /* Conversions */ }}%</th>
              </tr>
            </thead>
          </table>
        </card>
      </section>

      <section v-if="AllConversionActions.length" class="widget campaign-widget">
        <h3 class="widget-title">Resumen de Conversions</h3>
        <conversion-table :conversionArray="AllConversionActions" />
      </section>

      <div class="widget-area audience-report one-column" v-if="audienceInteractionSeries.length">
        <section class="widget">
          <h3 class="widget-title">Interacción de sus audiencias</h3>
          <card>
            <apexchart
              type="pie"
              width="380"
              :options="audienceInteractionChartOptions"
              :series="audienceInteractionSeries"
            />
          </card>
          <p style="font-style: italic;">
            Se muestran los resultados de mayor volumen con un límite de 5
            elementos
          </p>
        </section>
      </div>

      <div class="widget-area demographic-data">
        <h3 class="widget-title" v-if="ageSeries[0].data.length || genderSeries[0].data.length">Datos demográficos sobre sus usuarios</h3>
        <section class="widget" v-if="genderSeries[0].data.length">
          <h5 class="widget-title">Edad</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="genderChartOptions.xaxis.categories"
              :series="genderSeries[0].data"
              :bar="true"
            />
          </card>
        </section>
        <section class="widget" v-if="ageSeries[0].data.length">
          <h5 class="widget-title">Género</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="ageChartOptions.xaxis.categories"
              :series="ageSeries[0].data"
              :bar="true"
            />
          </card>
        </section>
        <section class="widget full-column">
          <h5 class="widget-title">Dispositivos</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="devicesChartOptions.xaxis.categories"
              :series="devicesSeries[0].data"
              :bar="false"
            />
          </card>
        </section>
      </div>
      <h3 class="widget-title" v-if="ADS.length > 0">Un vistazo a sus anuncios de búsqueda</h3>
      <div class="widget-area two-column" v-if="ADS.length > 0">
        <div class="widget ad-views">
          <div class="cards-wrapper carousel-google">
            <card>
              <SeacrhADS :ads="ADS" />
            </card>
          </div>
        </div>
        <div class="cards-calls-website"></div>
      </div>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import ViewOptions from "@/components/ViewOptions.vue";
import AdGoals from "@/components/Widgets/AdGoals.vue";
import Impressions from "@/components/ApexchartCustom/Impressions.vue";
import ApexchartBar from "../../components/ApexchartCustom/ApexchartBar";
import ConversionTable from "../../components/ConversionTable";
import { mapGetters } from "vuex";
import SeacrhADS from "../../components/search-ADS";
// import AudienceTable from "../../components/AudienceTable.vue";

// REQUEST
import adwordsGoogleMaxPerformance from "../../services/Fase2/adwordGoogleMaxPerformance";
import { validateProductExpirationDate } from "../../util";

export default {
  name: "google-max-performance",
  components: {
    ViewOptions,
    AdGoals,
    Impressions,
    ApexchartBar,
    SeacrhADS,
    ConversionTable
    // AudienceTable
  },
  data() {
    return {
      ConversionActions: [],
      AllConversionActions: [],
      TotalCampains: {
        Impresiones: 0,
        Clicks: 0,
        CTR: 0,
        CPC: 0,
        Conversions: 0
      },
      TotalLocationCampains: {
        Impresiones: 0,
        Clicks: 0,
        Conversions: 0,
        ConversionRate: 0
      },
      TotalPhoneCalls: 0,
      isAxesa: 0,
      isTrue: false,
      haveAudience: false,
      Product: [],
      PhoneCalls: [],
      ADS: [],
      wordings: {
        Impressions:
          "Cantidad de veces que su publicidad fue expuesta a su público objetivo",
        Clicks: "Interacciones con la audiencia"
      },
      productData: {
        totalImpressions: 0,
        totalClicks: 0
      },
      audienceInteractionSeries: [],
      audienceInteractionChartOptions: {
        colors: [
          "#0A286E",
          "#0E3593",
          "#1248C9",
          "#3772FF",
          "#08ACFF",
          "#93ABE6",
          "#BECDF0"
        ],
        labels: [],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      keywordDataTotal: {},
      keywordData: [],
      campaignData: [],
      campaignLocationData: [],

      impressionsSeries: [
        {
          name: "Impresiones",
          data: []
        },
        {
          name: "Clicks",
          data: []
        }
      ],
      impressionsChartOptions: {
        tooltip: {
          x: {
            show: true,
            format: "dd MMM",
            formatter: undefined
          },

          y: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return value.toLocaleString();
            }
          }
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ],
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          // width: [5, 7, 5],
          curve: "smooth"
        },
        markers: {
          size: 0,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: "#f1f1f1"
        }
      },
      genderSeries: [
        {
          data: []
        }
      ],
      genderChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      ageSeries: [
        {
          data: []
        }
      ],
      ageChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      devicesSeries: [
        {
          data: []
        }
      ],
      devicesChartOptions: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      adListings: [
        {
          listingIframeUrl:
            "http://caribemediadigital-betaui.azurewebsites.net/Get/Index/70894_16_SD",
          adData: {
            impressions: 1000,
            clicks: 50,
            ctr: 5
          }
        }
      ],
      searchData: {
        calls: 0,
        websiteVisits: 0,
        websiteLinks: []
      }
    };
  },
  watch: {
    date1: {
      handler() {
        this.reload(this);
      },
      deep: true
    },

    date2: {
      handler() {
        this.reload(this);
      },
      deep: true
    }
  },
  async created() {
    const context = this;
    await this.reload(context);
  },
  methods: {
    reload: async function(context) {
      context.TotalCampains.Impresiones = 0;
      context.TotalCampains.Clicks = 0;
      context.TotalCampains.CTR = 0;
      context.TotalCampains.CPC = 0;
      context.TotalCampains.Conversions = 0;
      context.TotalPhoneCalls = 0;
      context.phoneCalls = [];
      context.TotalLocationCampains.Impresiones = 0;
      context.TotalLocationCampains.Clicks = 0;
      context.TotalLocationCampains.Conversions = 0;

      context.ageSeries[0].data = [];
      context.genderSeries[0].data = [];
      context.devicesSeries[0].data = [];

      context.ageChartOptions.xaxis.categories = [];
      context.genderChartOptions.xaxis.categories = [];
      context.devicesChartOptions.xaxis.categories = [];

      context.campaignData = [];
      context.keywordData = [];
      context.keywordDataTotal = {};

      if (localStorage.getItem("isAxesa") == 1) {
        this.isAxesa = 1;
      }

      const { businessUnitId, subscriberId, productId } = context.$route.params;
      const { customerId } = context.$route.query;

      const products = context.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(products,productId,context.$store.state.subscriber.date1)

      let fromDate = context.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : context.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;

      const objKeyword = [];
      const pages = [];
      const keywordClicksAndImpressions = {
        TotalClicks: 0,
        TotalImpressions: 0,
        TotalCtr: 0,
        TotalCpc: 0
      };

      const objKeywordsData = {
        Clicks: [],
        Impressions: []
      };

      const product = {
        clicks: [],
        impressions: [],
        totalImpressions: 0
      };
      const campaign = [];
      const campaignLocation = [];

      const googleSearch = await new adwordsGoogleMaxPerformance(
        context
      ).getGoogleSearch(
        subscriberId,
        businessUnitId,
        fromDate,
        toDate,
        customerId
      );

      const googleSearchPages = await new adwordsGoogleMaxPerformance(
        context
      ).getGoogleSearchPages(subscriberId, businessUnitId, fromDate, toDate);

      const pagesUnic = new Set(pages);
      const conversionActions = [];

      context.ConversionActions = googleSearch.conversionActions;

      if (context.ConversionActions.length > 0) {
        context.ConversionActions.map(({ conversionActionRows }) => {
          return conversionActionRows.map(actions => {
            conversionActions.push({
              allConversion: actions.allConversion,
              conversionAction: actions.conversionAction
            });
          });
        });
      }

      context.AllConversionActions = conversionActions;

      (pagesUnic || []).forEach(element => {
        if (context.searchData.websiteLinks.length <= 2) {
          context.searchData.websiteLinks.push({ name: element });
        }
      });

      context.haveAudience = googleSearch.userListTarget.isUserTargetSet;
      context.searchData.websiteVisits = googleSearchPages ? googleSearchPages.quantity : null;

      context.productData.totalImpressions = googleSearch.totalImpressions;
      context.productData.totalClicks = googleSearch.totalClicks;
      context.totalConversions = 0;

      //Phone Calls
      (googleSearch.phoneCall || []).forEach(element => {
        context.phoneCalls.push({
          campaignName: element.campaignName,
          phoneCalls: element.phoneCalls,
          phoneImpressions: element.phoneImpressions
        });
        context.TotalPhoneCalls += element.phoneCalls;
      });

      let totalCampaignInteractions = 0;

      googleSearch.audiences.splice(0, 5).forEach(element => {
        context.audienceInteractionSeries.push(element.impressions);
        context.audienceInteractionChartOptions.labels.push(element.criteria);
      });

      // campaing
      (googleSearch.campaigns || []).forEach(element => {
        let phoneCall = 0;

        context.phoneCalls.map(x => {
          if (x.campaignName == element.campaignname) {
            return (phoneCall = x.phoneCalls);
          }
        });

        campaign.push({
          name: element.campaignname,
          impressions: element.impressions,
          clicks: element.clicks,
          ctr: element.ctr,
          cpc: element.cpc,
          conversion: element.conversions,
          phoneCalls: phoneCall,
          conversionRate: element.conversionRate || 0
        });
        context.totalConversions += element.conversions;
        totalCampaignInteractions += element.interactions || 0;
      });
      context.TotalCampains.Impresiones = googleSearch.totalImpressions;
      context.TotalCampains.Clicks = googleSearch.totalClicks;
      context.TotalCampains.CTR = googleSearch.totalCtr;
      context.TotalCampains.CPC = googleSearch.totalCpc;
      context.TotalCampains.Conversions = context.totalConversions;
      context.TotalCampains.ConversionRate = (
        (context.totalConversions) / (totalCampaignInteractions == 0 ? 1 : totalCampaignInteractions)
      )*100;
      

      let totalInteractions = 0;

      // campaing Locations
      if (googleSearch.campaignsLocation) {
        (googleSearch.campaignsLocation.slice(0, 10) || []).forEach(element => {
          campaignLocation.push({
            name: element.campaignname,
            location: element.locationname,
            impressions: element.impressions,
            clicks: element.clicks,
            ctr: element.ctr,
            cpc: element.cpc,
            conversion: element.conversions,
            conversionRate: element.conversionRate
          });
          totalInteractions += element.interactions;
          context.TotalLocationCampains.Impresiones += element.impressions;
          context.TotalLocationCampains.Clicks += element.clicks;
          context.TotalLocationCampains.Conversions += element.conversions;
        });
      }

      context.TotalLocationCampains.ConversionRate = (
        (context.TotalLocationCampains.Conversions) / (totalInteractions == 0 ? 1 : totalInteractions)
      )*100;

      // impressions and clicks
      (googleSearch.impressionsAndClicks || []).forEach(element => {
        context.impressionsSeries[0].data.push(element.impressions);
        context.impressionsSeries[1].data.push(element.clicks);
        context.impressionsChartOptions.xaxis.categories.push(element.date);

        product.clicks.push({ count: element.clicks, date: element.date });
        product.impressions.push({
          count: element.impressions,
          date: element.date
        });
      });

      //  keyword
      if (googleSearch.keywords) {
        (googleSearch.keywords.slice(0, 10) || []).forEach(element => {
          objKeyword.push({
            keyword: element.criteria,
            impressions: element.impressions,
            clicks: element.clicks,
            ctr: element.ctr,
            cpc: element.cpc
          });

          objKeywordsData.Clicks.push(element.clicks);
          objKeywordsData.Impressions.push(element.impressions);
          keywordClicksAndImpressions.TotalCpc = googleSearch.totalCpc;
        });
      }

      keywordClicksAndImpressions.TotalClicks = objKeywordsData.Clicks.length ? Number(
        (objKeywordsData.Clicks || []).reduce(
          (accumulator, currentValue) => accumulator + currentValue
        )
      ) : 0;
      keywordClicksAndImpressions.TotalImpressions = objKeywordsData.Impressions.length ? Number(
        (objKeywordsData.Impressions || []).reduce(
          (accumulator, currentValue) => accumulator + currentValue
        )
      ) : 0;
      keywordClicksAndImpressions.TotalCtr =
        (Number(keywordClicksAndImpressions.TotalClicks) /
          Number(keywordClicksAndImpressions.TotalImpressions)) *
        100;
      /* ) * 100
      )*/

      // age
      (googleSearch.ages || []).forEach(element => {
        if (element.criteria) {
          context.ageChartOptions.xaxis.categories.push(element.criteria);
          context.ageSeries[0].data.push(element.impressions);
        }
      });
      // gender
      (googleSearch.genders || []).forEach(element => {
        if (element.criteria) {
          const filterCriteria = element.criteria.replace("to"," to ")
          context.genderChartOptions.xaxis.categories.push(filterCriteria);
          context.genderSeries[0].data.push(element.impressions);
        }
      });
      //DEVICE
      (googleSearch.devices || []).forEach(element => {
        if (element.criteria) {
          if (element.criteria.includes("Devices")) {
            context.devicesChartOptions.xaxis.categories.push("TV");
          } else {
            context.devicesChartOptions.xaxis.categories.push(
              element.criteria.split(" ")[0]
            );
          }

          context.devicesSeries[0].data.push(element.impressions);
        }
      });

      // ADS
      const Ads = googleSearch.ads;
      context.ADS = Ads;
      context.keywordData = objKeyword;
      // context.searchData.calls = googleSearch.phoneCall.clicks;
      context.Product = product;
      context.campaignData = campaign;
      context.campaignLocationData = campaignLocation;
      context.keywordDataTotal = keywordClicksAndImpressions;
    }
  },
  computed: {
    ...mapGetters(["date1", "date2"])
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: none;
}
.responsive-table {
  overflow-x: scroll;
}
.ad-data-copy {
  display: grid;
  justify-content: space-evenly;
  align-content: center;
  margin-top: 15px;
  flex-direction: column;
  grid-template-columns: 1fr 1fr 1fr;
  .data {
    margin-bottom: 10px;
    text-align: center;
    &:last-child {
      border-right: 0px;
    }
    h5 {
      color: $highlight-color;
    }
    p {
      font-size: 12px;
    }
  }
}
.google-box-content {
  > img {
    width: 60px;
    margin: 0 auto;
    display: block;
    margin-bottom: 10px;
  }
  .search-box {
    background-color: #fff;
    border-radius: 5px;
    .search-input {
      display: flex;
      justify-content: space-between;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 40px;
      overflow: hidden;
      box-sizing: border-box;
      p {
        font-size: 12px;
        padding: 8px 0px 8px 15px;
        margin-bottom: 0px;
        align-self: flex-start;
        color: $blueish-gray-700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .search-icon {
        background-color: $google;
        width: 40px;
        height: 36px;
        border-top-right-radius: 5px;
        align-self: flex-end;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .search-options {
      overflow: hidden;
      padding: 0px;
      margin-top: 5px;

      ul {
        display: flex;
        li {
          padding: 5px 10px;
          color: #c0c0c0;
          text-transform: uppercase;
          font-size: 8px;
          font-weight: $font-medium;
          &.active {
            color: $google;
            border-bottom: 2px solid $google;
          }
        }
      }
    }
  }
  .search-results {
    margin-top: 10px;
    padding: 10px;
    background-color: #fff;
    box-shadow: $blueShadow;
    border-radius: 5px;
    max-height: 175px;
    .result-title {
      color: $google;
      margin-bottom: 0px;
      font-size: 12px;
      text-align: left;
    }
    .result-url {
      display: flex;
      align-items: baseline;
      span {
        color: #66c18d;
        padding: 0px 2px;
        border: 1px solid #66c18d;
        border-radius: 5px;
        font-size: 10px;
        margin-right: 5px;
      }
      p {
        color: #66c18d;
        font-size: 10px;
        margin-bottom: 7px;
      }
    }
    .result-separator {
      width: 100%;
      height: 1px;
      background: #e0e0e0;
    }
    .result-description {
      p {
        font-size: 10px;
        margin: 5px 0px 0px 0px;
        text-align: left;
      }
    }
  }
}
.demographic-data {
  h5 {
    font-size: 16px;
    color: $blueish-gray-600;
  }
}

.full-column {
  grid-column: 1 / -1;
}

@include respond-above(ss) {
  .google-box-content {
    max-width: 350px;
    margin: 0 auto;
    > img {
      width: 70px;
    }
    .search-results {
      .result-title {
        font-size: 12px;
      }
      .result-url {
        p {
          font-size: 12px;
        }
      }
      .result-description {
        p {
          font-size: 12px;
        }
      }
    }
  }
}

@include respond-above(md) {
  .product-view {
    display: grid;
    grid-template: 1fr auto / 1fr minmax(300px, 350px);
    grid-column-gap: 30px;
    max-width: 1000px;
    margin: 0 auto;
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
    .widget {
      &.keyword-widget,
      &.campaign-widget {
        grid-column: 1 / -1;
      }
    }
    .separator {
      grid-column: 1 / -1;
      margin-bottom: 20px;
    }
    .demographic-data {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 30px;
      & > .widget-title {
        text-align: center;
        grid-column: 1 / -1;
        margin-bottom: 30px;
      }
      .widget:nth-child(4) {
        grid-column: 1 / -1;
      }
    }
    .two-column {
      grid-column: 1 / -1;
    }
    .ad-views {
      grid-column: 1 / -1;
      .cards-wrapper {
        display: grid;
        grid-gap: 30px;
      }
    }
  }
  .google-box-content {
    > img {
      width: 90px;
    }
    .search-box {
      .search-input {
        p {
          font-size: 14px;
        }
      }
      .search-options {
        ul {
          li {
            font-size: 10px;
            padding: 7px 15px;
          }
        }
      }
    }
    .search-results {
      max-height: 145px;
      .result-title {
        font-size: 14px;
      }
    }
  }
}

.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  .ad-data {
    ul {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
  }

  .ad-views {
    grid-column: 1 / -1;
    .ad-listing {
      padding: 0;
    }
  }
  .cards-calls-website {
    grid-column: 1 / -1;
  }
}

.ad-data {
  text-align: center;
  h1 {
    font-size: 52px;
    font-weight: 500;
    color: #3576ff;
  }
}

@include respond-above(sm) {
  .two-column {
    .ad-views {
      grid-column: 1;
    }
    .cards-calls-website {
      grid-column: 2;
    }
    .ad-data {
      &.calls {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

// loading

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
